import { string, object } from "yup";

export const phoneInitialValues = ({ phone }) => ({
  phone: phone || "",
});

export const phoneValidationSchema = object({
  phone: string().min(4, "Invalid Phone").max(18, "Invalid Phone"),
});

export const codeInitialValues = {
  code: "",
};

export const codeValidationSchema = object({
  code: string()
    .trim()
    .max(6, "Must be 6 characters or less")
    .required("Required"),
});
